import React from 'react'

import clsx from 'clsx'

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'small' | 'medium' | 'large'
  variant?: 'primary' | 'secondary'
  label?: string
  disabled?: boolean
}

export const Checkbox = ({
  size = 'medium',
  variant = 'primary',
  label = '',
  disabled = false,
  ...props
}: CheckboxProps) => {
  const defaultInputClass = 'form-checkbox rounded focus:ring-2 focus:ring-offset-2'

  // Defines the size of the checkbox
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-5 h-5',
    large: 'w-6 h-6',
  }[size]

  // Adjusts the text size and color based on the size of the checkbox
  const textClasses = {
    small: 'text-xs text-gray-600',
    medium: 'text-sm text-gray-800',
    large: 'text-md text-gray-900',
  }[size]

  // Determines the visual style of the checkbox (color, border, focus state)
  const variantClasses = {
    primary: 'text-[#18343B] border-[#18343B] focus:ring-[#18343B]',
    secondary: 'text-[#C44322] border-[#C44322] focus:ring-[#C44322]',
  }[variant]

  return (
    <label className={clsx('flex items-center space-x-2', disabled && 'cursor-not-allowed opacity-50')}>
      <input
        type="checkbox"
        className={clsx(defaultInputClass, sizeClasses, variantClasses, disabled && 'bg-gray-300')}
        disabled={disabled}
        {...props}
      />
      <span className={clsx(textClasses)}>{label}</span>
    </label>
  )
}
